import { Divider } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import UserLookupFormik from "../userLookup/UserLookupFormik";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
const Container = styled.div`
    width:100%
    padding:20px;
    display:grid;
    grid-template-columns: 40px minmax(50px,200px) 250px 250px;
    align-items:flex-end;
    padding-top:30px;
    justify-content:center;
    
`;

const StepCount = styled.div`
  text-align: center;
  color: white;
  border-radius: 50%;
  height: 25px;
  line-height: 25px;
  background: gray;
  width: 57px;
`;

const StepCountContainer = styled.div`
    padding-right:10px;
`;

const StepLabelContainer = styled.div`width:100%; padding-right:15px;  padding-left: 30px;`;

const User = styled.div``;

const IWPPWorkflowStep = ({
  arrayHelpers,
  index,
  formProps,
  editable,
  isGbu
}) => {
  const workflowstep = formProps.values.workflowSteps[index];
  const { primary, proxy } = workflowstep;  
  return (
    <>
      <Container key={index}>
        <StepCountContainer>         
           <StepCount style={{  background: index===0 ?"#00bcd4":'gray' }}>
            {index===0 ? "Primary" : "Proxy"}
          </StepCount>
        </StepCountContainer>
        <StepLabelContainer>
        <Field name={`workflowSteps.${index}.stepLabel`} component={TextField} label="Title" fullWidth />
        </StepLabelContainer>
          <User>
            <UserLookupFormik
              setFieldValue={formProps.setFieldValue}
              setFieldTouched={formProps.setFieldTouched}
              field={`workflowSteps.${index}.${index===0 ? "primary" : "proxy"}`}
              value={index===0 ? primary : proxy}
            />
          </User>
      </Container>
      <Divider />
    </>
  );
};

export default IWPPWorkflowStep;
